import { Navigate } from "react-router-dom";
import { ReactElement } from "react";
import { rejectNonAdminAdminSession } from "../utils/adminAuthGate";

export const ProtectedRoute = ({ children }: { children: ReactElement }) => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  const companyPortalUrl = rejectNonAdminAdminSession();
  if (companyPortalUrl) {
    return <Navigate to="/login" replace state={{ companyPortalUrl }} />;
  }

  return children;
};
